module.exports = __webpack_public_path__ + "img/901550800.a1ad0865.png";